import type { MerchantLinkData } from '../../core/types/MerchantLinkData';

export const getMerchantDataFromWidgetPlaceholder = (
  placeholder: Record<string, string>,
): MerchantLinkData => {
  return {
    id: placeholder['data-merchant-id'] ? Number(placeholder['data-merchant-id']) : undefined,
    name: placeholder['data-merchant-name'],
    url: placeholder['data-merchant-url'],
    network: placeholder['data-merchant-network'],
    trackingPixelUrl: placeholder['data-tracking-pixel-url'],
  };
};
